<!--
收货信息

使用说明：

<UserAddress
 :address="[{UserAddress}]"
 />

UserAddress={
  addressId: 0,
  areaId: 0,
  detail: '具体地址',
  reciever: '收件人',
  contact: '收件人联系方式'
}
-->

<template>
	<div class="wrap">
		<transition name="slideup">
			<div class="address-float-box" v-show="ui.show">
				<!-- <div class="title">请选择收货地址</div> -->
				<Icon
					class="icon-dialog-close"
					v-on:click.native="closeAddressList()"
					:img="require('../../../assets/icon-address-close.png')"
				/>
				<!-- <div class="address-list">
					<div
						class="address"
						:class="{ selected: curr && curr.id == c.id }"
						v-for="c in address"
						:key="'address-' + c.id"
					>
						<div class="recieve-wrap">
							<div class="reciever" @click.stop="select(c)">{{ c.receiver }}</div>
							<div class="contact" @click.stop="select(c)">{{ c.telephone }}</div>
						</div>

						<div class="detail" @click.stop="select(c)">{{ c.area + c.detail }}</div>
						<div class="flex-wrap action-wrap">
							<div
								class="default-address flex-wrap"
								v-bind:class="c.defaultAddress"
								@click="setDefault(c)"
							>
								<Icon
									class="icon"
									v-if="c.defalultIcon"
									:img="require('../../../assets/xuanzhong_press_icon.png')"
								/>
								<Icon class="icon" v-else :img="require('../../../assets/xuanzhong_normal_icon.png')" />
								设为默认
							</div>
							<div class="flex-wrap">
								<a class="write-btn flex-wrap" @click="goTo('/pages/setting/EditAddress?id=' + c.id)">
									<Icon class="icon" :img="require('../../../assets/bianji_icon.png')" />
									编辑
								</a>
								<div class="delete-btn flex-wrap" @click.stop="deleteAddress(c)">
									<Icon class="icon" :img="require('../../../assets/shanchu_icon.png')" />
									删除
								</div>
							</div>
						</div>
					</div>
				</div> -->
				<div class="address-list">
					<div
						class="address"
						:class="{ selected: curr && curr.id == c.id }"
						v-for="c in address"
						:key="'address-' + c.id"
					>
						<div class="reciever" @click.stop="select(c)">{{ c.receiver }}</div>
						<div class="contact" @click.stop="select(c)">{{ c.telephone }}</div>
						<div class="detail" @click.stop="select(c)">{{ c.area + c.detail }}</div>
						<a href="javascript:;" class="delete-btn" @click.stop="deleteAddress(c)">
							<Icon
								class="icon"
								v-if="curr && curr.id == c.id"
								:img="require('../../../assets/icon-address-del-active.png')"
							/>
							<Icon class="icon" v-else :img="require('../../../assets/icon-address-del.png')" /> 删除
						</a>
					</div>
				</div>
				<ActionButton class="actions" text="新建地址" v-on:click.native="$emit('onAddAddress')" />
			</div>
		</transition>
	</div>
</template>

<script>
import $ from 'jquery';
import ActionButton from '@/components/products/form/ActionButton';
import api from '../../../api';

export default {
	props: ['address', 'curr'],
	components: {
		ActionButton,
	},
	data() {
		return {
			ui: {
				show: false,
			},
		};
	},
	methods: {
		showAddressList() {
			console.log(this.$route.query.cart)
			var cartId = this.$route.query.cart
			this.$router.push('../../pages/payment/SelectAddress?cart='+cartId);
			// $('body').addClass('frozen');
			// var padding = 10 * ($('body').width() / 100);
			// $('.address-list').css({
			// 	height:
			// 		$('body').height() -
			// 		$('.address-float-box .title').height() -
			// 		$('.address-float-box .actions').height() -
			// 		padding +
			// 		'px',
			// });
			// this.ui.show = true;
		},
		closeAddressList() {
			$('body').removeClass('frozen');
			this.ui.show = false;
		},
		select(address) {
			this.$emit('onAddressChange', address);
			this.closeAddressList();
		},
		deleteAddress(address) {
			this.$confirmDialog('确认删除？', (btn) => {
				if (btn == '确定') {
					api.order.deleteAddress(
						address.id,
						(res) => {
							this.$toast('删除成功');
							this.$emit('onAddressReload');
						},
						(r) => {
							this.$alertDialog(r.msg);
						}
					);
				}
			});
		},
	},
};
</script>

<style lang="less" scoped>
.wrap {
	position: relative;
	z-index: 13;
	color: #333333;
	//border-top: 1px solid #eaebed;
	.title {
		font-size: 3.6vw;
		padding-left: 4vw;
		line-height: 10.93vw;
	}
	.change-btn {
		background: transparent;
		border: none;
		color: #3c3c3c;
		font-size: 3.466vw;
		width: 17vw;
		text-align: center;
		vertical-align: top;
		position: absolute;
		top: 4.6vw;
		right: 4.1vw;
		.icon {
			width: 4.16vw;
			height: 4.16vw;
			margin-right: 1vw;
			display: inline-block;
			vertical-align: top;
		}
	}
	.address-list {
		padding-bottom: 17vw;
	}
	.address {
		padding: 3.87vw 4.13vw;
		background: #fff;
		border-top: 1px solid #f5f5f5;

		.detail {
			font-size: 3.47vw;
			color: #999;
			margin: 3.6vw auto;
		}
	}
	.recieve-wrap {
		font-size: 4vw;
		color: #404040;
		display: flex;
		justify-content: space-between;
	}
	.flex-wrap {
		display: flex;
	}
	.action-wrap {
		display: flex;
		justify-content: space-between;
		.icon {
			width: 3.47vw;
			height: 3.47vw;
			margin-right: 2vw;
		}
	}
	.default-address,
	.write-btn,
	.delete-btn {
		align-items: center;
		font-size: 3.47vw;
		color: #333;
	}
	.write-btn {
		margin-right: 6.53vw;
	}
	.default-address {
		color: #999;
	}
	.default-address.true {
		color: #ff3333;
	}
	.address {
		background: #fff;
		border-radius: 2.4vw;
		padding: 6vw;
		width: 91.73vw;
		box-sizing: border-box;
		-webkit-box-sizing: border-box;
		margin: 4vw auto;
		position: relative;
		.reciever,
		.contact {
			display: inline-block;
			line-height: 1em;
			margin-bottom: 2.66vw;
			margin-right: 4.8vw;
			color: #333;
			font-size: 3.733vw;
		}
		.detail {
			color: #666666;
			font-size: 3.733vw;
		}
		.delete-btn {
			display: inline-block;
			font-size: 3.46vw;
			width: 4em;
			position: absolute;
			top: 5.86vw;
			right: 4.8vw;
			color: #3c3c3c;
			.icon {
				height: 4.26vw;
				width: 4.26vw;
				display: inline-block;
				vertical-align: top;
			}
		}
		&.selected {
			background: #ff9933;
			.reciever,
			.contact {
				color: #fff;
			}
			.detail {
				color: #fff;
			}
			.delete-btn {
				color: #fff;
			}
		}
	}
}

.address-static-box {
}

.address-float-box {
	position: fixed;
	z-index: 20;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: #f2f2f2;

	.title {
		color: #000;
		text-align: center;
		font-size: 4.266vw;
		line-height: 3em;
	}
	.icon-dialog-close {
		width: 2.8vw;
		height: 2.8vw;
		position: fixed;
		z-index: 21;
		top: 5.2vw;
		right: 4vw;
	}

	.address-list {
		overflow-y: auto;
	}

	.actions {
		position: fixed;
		z-index: 21;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/products/form/UserAddress.vue